module.exports = __webpack_public_path__ + "static/media/jane_doe.050c2f6e.jpg";